export default __webpack_public_path__ + "static/media/ms.012a60e1.svg";